<template>
    <v-app>

        <Drawer current_item="menu_automessage"></Drawer>

        <v-main class="ml-6 mr-6">
          <v-banner single-line :sticky="true" style="background-color:white">
              <v-row align="end" justify="space-between">
              <v-col cols="12" md="4" class="text-md-h4 text-h5" align="left">
                  ข้อความอัตโนมัติ
                  </v-col>
              <v-col cols="12" md="4" align="left">
                  <v-btn v-if="permission.includes('EDIT_automessage')" tile color="success" @click="submitChange" :disabled="!is_change" >
                      <v-icon left>mdi-check</v-icon>{{ $t('config_submit') }}
                  </v-btn>
              </v-col>
              <v-col cols="12" md="4" align="left">
                  <FragmentSelectStation :station_code="$route.params.station_code" @onchange="onStationChange"></FragmentSelectStation>
              </v-col>
              </v-row>
          </v-banner>
            <v-divider class="mb-6"></v-divider>

            <v-simple-table fixed-header align="left" >
            <thead>
                <tr>
                <th class="text-left" width="10%">ข้อความที่</th>
                <th class="text-left" width="40%">{{ $t('setting') }}</th>
                <th class="text-left" width="50%">{{ $t('message') }}</th>
                </tr>
            </thead>
            <tbody >
                <tr v-for="item in noti_settings" :key="item.noti_tag"> 
                    <td class="pt-4" align="center">
                        {{ item.noti_tag }}
                    </td>
                    <td class="pt-4">
                        <v-row>
                        <v-col cols="12" :md="item.noti_setting.value.includes('remind_') ? 8 : 12">
                        <v-select
                          :value="item.noti_setting.value.includes('remind_') ? 'remind' : item.noti_setting.value"
                          @change="(val)=>onchange('noti_id_' + item.noti_tag,val,item.noti_tag)"
                          :items="noti_selection"
                          item-text="name"
                          item-value="val"
                          single-line
                          outlined
                          dense
                        ></v-select>

                        <FragmentSelectGroup 
                            v-if="item.noti_setting.value!='disabled' && (item.noti_setting.value.includes('appointment_') || item.noti_setting.value.includes('remind_'))"
                            @ongroup="(val)=>onchange('group_' + item.noti_tag,val,item.noti_tag)"
                            :station_code="$route.params.station_code" 
                            :multiple="true"
                            :have_group_0="false"
                            :init_selectedItems="item.noti_setting.group == undefined ? grouplist.map(g=>g.group_id) : item.noti_setting.group"
                        ></FragmentSelectGroup>

                        <v-tooltip bottom v-if="item.noti_setting.value!='disabled'">
                            <template v-slot:activator="{ on, attrs }">
                                <div v-bind="attrs" v-on="on">
                                    <v-icon color="primary" dark>
                                        mdi-help-circle
                                    </v-icon>
                                    คำแนะนำ
                                </div>
                            </template>
                            <span align="left">
                                <ul>
                                    <li>{station_name} = ชื่อจุดบริการ</li>
                                    <li v-if="item.noti_setting.value.includes('appointment_') || item.noti_setting.value.includes('remind_')">{group_name} = ชื่อกลุ่มงานบริการ</li>
                                    <li v-if="item.noti_setting.value.includes('appointment_') || item.noti_setting.value.includes('remind_')">{date} = วันที่นัดหมาย</li>
                                    <li v-if="item.noti_setting.value.includes('appointment_') || item.noti_setting.value.includes('remind_')">{time} = ช่วงเวลานัดหมาย</li>
                                </ul>
                            </span>
                        </v-tooltip>
                        </v-col>
                        <v-col cols="12" md="3" v-if="item.noti_setting.value.includes('remind_')">
                          <v-text-field
                            :value="item.noti_setting.value.replace('remind_','')"
                            @change="(val)=>onchange('noti_remind_' + item.noti_tag,val,item.noti_tag)"
                            single-line
                            outlined
                            dense
                          ></v-text-field>
                        </v-col>
                          <v-col cols="12" md="1" class="mt-3" v-if="item.noti_setting.value.includes('remind_')">
                          นาที
                          </v-col>
                        </v-row>
                    </td>
                    <td class="pt-4">
                        <v-textarea
                            :value="noti_messages['noti_message_'+item.noti_tag]"
                            @change="(val)=>onchange('noti_message_' + item.noti_tag,val,item.noti_tag)"
                            class="mt-1"
                            outlined
                            :rows="item.noti_setting.value=='disabled' ? 2 : 6"
                            :disabled="item.noti_setting.value=='disabled'"
                        ></v-textarea>
                    </td>
                </tr>
            </tbody>
        </v-simple-table>

        </v-main>
    </v-app>
</template>

<style>
.time-picker-modal-container{
  width:inherit
}
.outside-click-container{
  left:77%
}
</style>

<script>
import Drawer from '@/components/Drawer.vue'
import FragmentSelectStation from '@/components/Common/FragmentSelectStation.vue'
import FragmentSelectGroup from '@/components/Common/FragmentSelectGroup.vue'
import config from '@/../config.js'
import Staff from '@/model/instance/Staff.js'
import axios from 'axios';

export default {
  components: {
    Drawer
    ,FragmentSelectStation
    ,FragmentSelectGroup
  },
  data () {
    return {
      old_noti_setting : {}
      ,old_noti_message : {}
      ,noti_settings : []
      ,noti_messages : {}
      ,noti_selection: [
          {val:'disabled',name:'ปิดการใช้งาน'}
          ,{val:'remind',name:'ส่งก่อนเวลานัดหมาย'}
          ,{val:'appointment_new_member_hold',name:'ส่งเมื่อสมาชิกจองคิว (รอจนท.ตอบรับนัด)'}
          ,{val:'appointment_new_member_pass',name:'ส่งเมื่อสมาชิกจองคิว (ไม่รอจนท.ตอบรับนัด)'}
          ,{val:'appointment_accept',name:'ส่งเมื่อจนท.ตอบรับนัด'}
          ,{val:'appointment_reject',name:'ส่งเมื่อจนท.ปฏิเสธนัด'}
          ,{val:'appointment_new_staff',name:'ส่งเมื่อจนท.สร้างนัดหมายใหม่'}
          ,{val:'appointment_cancel_staff',name:'ส่งเมื่อจนท.ยกเลิกนัดหมาย'}
          ,{val:'appointment_cancel_user',name:'ส่งเมื่อสมาชิกยกเลิกนัดหมาย'}
          ,{val:'appointment_edit_date',name:'ส่งเมื่อจนท.เลื่อนวันเวลานัดหมาย'}
          ,{val:'appointment_edit_station',name:'ส่งเมื่อจนท.โอนงานนัดหมาย'}
          ,{val:'appointment_activte_member',name:'ส่งเมื่อสมาชิกมาถึงแล้วตามนัดหมาย'}
          ,{val:'appointment_activte_staff',name:'ส่งเมื่อจทน.รับทราบว่ามาถึงแล้วตามนัดหมาย'}
          ,{val:'appointment_callback_callwait_calling',name:'ส่งเมื่อจนท.เรียกตัวสมาชิกมารับบริการตามคิว'}
          ,{val:'appointment_callback_callwait_completed',name:'ส่งเมื่อจนท.ให้บริการตามคิวเสร็จแล้ว'}
          ,{val:'appointment_overdue',name:'ส่งเมื่อสิ้นวันแล้วไม่มาตามนัดหมาย'}
          ,{val:'member_register_new',name:'ส่งเมื่อสมาชิกยื่นข้อมูลเพื่อสมัคร'}
          ,{val:'member_register_accept',name:'ส่งเมื่อข้อมูลในการสมัครสมาชิกได้รับการยืนยัน'}
          ,{val:'member_register_reject',name:'ส่งเมื่อข้อมูลการสมัครสมาชิกถูกปฏิเสธ'}
          ,{val:'member_register_delete',name:'ส่งเมื่อลบสมาชืก'}
          ,{val:'member_register_reject_duplicate',name:'ส่งเมื่อข้อมูลการสมัครสมาชิกถูกปฏิเสธ เพราะข้อมูลซ้ำ'}
          ,{val:'member_register_reject_api',name:'ส่งเมื่อข้อมูลการสมัครสมาชิกถูกปฏิเสธ เพราะ API not existing'}
          ,{val:'hyq_welcome',name:'ส่งเมื่อเริ่มติดตามคิว HyQ'}
          ,{val:'hyq_waiting',name:'ส่งเมื่อคิว HyQ แจ้งสถานะคิวล่าสุด'}
          ,{val:'hyq_calling',name:'ส่งเมื่อคิว HyQ เรียกคิว'}
      ],
      change_list : {},
      is_change : false,
      permission : [],
      grouplist : []
    }
  },
  mounted : function () {
    var que = this.$store.commit('addLoading')
      this.permission = Staff.getPermission('Automessage',this.$route.params.station_code).then(permission=>{
          console.log(permission)
          this.permission = permission

          axios
          .post(config.api.url.manage.appointment.manage.get_grouplist,{station_code:this.$route.params.station_code},{headers: Staff.getTokenHeader()})
          .then(response => {
              this.$store.commit('finishLoading',que)
              this.grouplist = response.data.grouplist
          })
      })
    this.reload()
  },
  methods : {
    reload(){

      this.is_change = false
      this.change_list = {}

      this.noti_settings = []
      var que = this.$store.commit('addLoading')
      axios
      .post(config.api.url.manage.station.get_notimessage
          ,{station_code:this.$route.params.station_code}
          ,{ headers: Staff.getTokenHeader()}
      ).then(response => {

        //this.old_noti_setting = response.data.noti_setting.map(s=>JSON.parse(s))
        this.old_noti_setting = response.data.noti_setting
        console.log(this.old_noti_setting)
        this.old_noti_message = response.data.noti_message
        this.noti_messages = response.data.noti_message
        Object.keys(response.data.noti_setting).forEach(n=>{
          var noti_tag = parseInt(n.replace('noti_id_',''))
          this.noti_settings.push({
            noti_tag : noti_tag
            ,noti_setting : JSON.parse(response.data.noti_setting[n])
          })
        })
        this.$store.commit('finishLoading',que)
      })
      .catch(error => {
          this.$router.push({name:'Error',params:error}) 
      })
    },
    onStationChange(station){
      document.location = station.station_code
    },
    onchange(field,val,tag){
      let isChange = false;

      if(field.includes('noti_remind_')){
        field = field.replace('noti_remind_','noti_id_')
        val = 'remind_' + val
      }

      if(field.includes('noti_id_')){
        if(val == 'remind'){
          val = 'remind_60'
        }
        this.noti_settings.forEach((n,i,arr)=>{
          if(n.noti_tag==tag){
            arr[i].noti_setting.value = val
            val = arr[i].noti_setting
          }
        })
      }

      if(field.includes('group_')){
        field = field.replace('group_','noti_id_')
        this.noti_settings.forEach((n,i,arr)=>{
          if(n.noti_tag==tag){
            arr[i].noti_setting['group'] = val.map(g=>g.group_id)
            if(this.grouplist.every(g => arr[i].noti_setting['group'].includes(g.group_id))){
              delete arr[i].noti_setting['group'];
            }
            val = arr[i].noti_setting
          }
        })
      }

      if(field.includes('noti_id_')){
        var old = JSON.parse(this.old_noti_setting[field])
        if(Object.keys(val).length != Object.keys(old).length){
          isChange = true
        }else if(val.value != old.value){
          isChange = true
        }else if(val.group != undefined){
          isChange = !val.group.every(g => old.group.includes(g)) || !old.group.every(g => val.group.includes(g))
        }
        if(isChange){
          this.change_list[field] = {
              field : field
              ,toid : this.$route.params.station_code
              ,params : {
                  station_code : this.$route.params.station_code
                  ,setting_tag : field
                  ,setting_value : JSON.stringify(val)
              }
          }
        }
      }else if(field.includes('noti_message_')){
        if(val != this.old_noti_message[field]){
          isChange = true;
          this.change_list[field] = {
              field : field
              ,toid : this.$route.params.station_code
              ,params : {
                  station_code : this.$route.params.station_code
                  ,setting_tag : field
                  ,setting_value : val
              }
          }
        }
      }
      if(!isChange){
        delete this.change_list[field];
      }
      console.log(this.change_list)
      this.is_change = Object.keys(this.change_list).length > 0
    },
    submitChange(){
        var que = this.$store.commit('addLoading')
        var change_data = [];
        Object.keys(this.change_list).forEach(k=>{
            change_data.push(this.change_list[k]);
        });
        axios
        .post(config.api.url.manage.save.config,{editlist:change_data},{ headers: Staff.getTokenHeader()})
        .then(() => {
            this.$store.commit('finishLoading',que)
            this.reload()
        }).catch(error => {
            this.$router.push({name:'Error',params:error}) 
        })
      }
  }
}
</script>